import { Matrix4 } from "three";
import { generatePolygonWKT } from "./exportUtils";
import { DataAOI } from "../types/interfaces";
import { message } from "antd";
import { findCurrentEPSGUnitUsingPClouds } from "./potreeUtils";
import { getProjectionFromDataIndex } from "../components/tables/dataIndexTable/DataIndexUtils";
import { LASDataClassification } from "./LASDataClassification";
import { handleResponse } from "./handleLambdaResponse";
import { getDataItemFromDataId, getDataItemsFromEntwinePathStore } from "../store/DataStore";

/**
 * @description This function returns the list of available epsg for the user to select
 * @returns {string[]} List of available epsg
 */
export function getTargetEPSGList() {
    // I think this should be coming from the API, for now it's hardcoded
    // Target epsg dropdown options
    const options = [
        {
            value: 'epsg 1',
            label: 'EPSG 1',
        },
        {
            value: 'epsg 2',
            label: 'EPSG 2',
        },
        {
            value: 'epsg 3',
            label: 'EPSG 3',
        },
    ];
    return options;
}

/**
 * @description This function return data for LAS export from the selected AOI
 * @param {DataAOI} data DataAOI object
 * @returns {any} Data for LAS export
 */
export const getDataForLASExport = (data: DataAOI) => {

    const polygonWKT = generatePolygonWKT(data)

    // get Input data IDs
    const visibleData : any = getVisibleData();

    const selectedClassifications: any = [];
    let hasInvisible = false;
    Object.keys(window.potreeViewer.classifications).forEach((key) => {
        const classData = window.potreeViewer.classifications[key];
        if (classData.visible) {
            // selectedClassifications.push(parseInt(key, 10));
            // For now, set DEFAULT as 20
            key === 'DEFAULT' ?
                selectedClassifications.push(20) :
                selectedClassifications.push(parseInt(key, 10));
        } else {
            hasInvisible = true;
        }
    });

    let unit = findCurrentEPSGUnitUsingPClouds();
    let dataForLASExport = {
        download_name: data.name,
        area: data.area.toFixed(2) + " " + unit + "²",
        epsg: data.epsg,
        polygon: polygonWKT,
        process: "download",
        visibleData : visibleData,
    }
    return dataForLASExport
}
/**
 * 
 * @description This function initiates the download of LAS files
 * @param {any} payload Payload for LAS export
 * @returns {void}
 */
export const exportLAS = (payload : any) => {
    return new Promise((resolve, reject) => {
        const params = {
            FunctionName: "downloader-dispatcher",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, (err: any, resultData: any) => {
            handleResponse(err, resultData, resolve, reject)
        });
    });
}

/**
 * 
 * @description This function initiates the download of LAS files for quick export
 * @param {any} payload Payload for LAS export
 * @returns {void}
 */
export const exportQuickLAS = (payload: any) => {
    return new Promise((resolve, reject) => {
        const params = {
            FunctionName: "downloader-dispatcher",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, (err: any, resultData: any) => {
            handleResponse(err, resultData, (res: any) => {
                message.success("Export initiated.");
                resolve(res);
            }, (err) => {
                message.error("Downloads are not enabled on your account.");
                reject(err);
            });
        });
    });
}

export function getVisibleData() {
    let pcs = window.potreeViewer.scene.pointclouds;

    let visiblePcs = pcs.filter((pc: any) => pc.visible);

    const visibleData: any = {};

    visiblePcs.forEach((pointcloud: any) => {
        const dataId = pointcloud.data_id;
        const dataItem = getDataItemFromDataId(dataId);
        
        if(!dataItem) return;

        const ownerId = dataItem.owner_id;

        // If owner id is not in visibleData, add it
        if (!(ownerId in visibleData)) visibleData[ownerId] = [];
        const entwinePath = dataItem.entwine_build_path;

        const uCustomFilterPointSourceIDs = pointcloud.uCustomFilterPointSourceIDs as Matrix4;
        const psIds = uCustomFilterPointSourceIDs.elements.filter((s) => s > 0);

        const items = getDataItemsFromEntwinePathStore(entwinePath);
        items.forEach((item) => {
            let epsgData = getProjectionFromDataIndex(item);
            let projection = epsgData.getCRS();
            if (item.show) {
                if (item.id_iterator) {
                    if (psIds.includes(parseInt(item.id_iterator, 10))) {
                        visibleData[ownerId].push({
                            data_id: item.data_id,
                            name: item.name,
                            projection: projection
                        });
                    }
                } else {
                    visibleData[ownerId].push({
                        data_id: item.data_id,
                        name: item.name,
                        projection: projection
                    });
                }
            }
        });
    });

    return visibleData;
}